module.exports = __webpack_public_path__ + "img/engine-oil-hub.7aee9c27.png";